"use strict";

exports.__esModule = true;
exports.default = exports.debugLogger = exports.Uppy = exports.UIPlugin = exports.BasePlugin = void 0;
var _Uppy = _interopRequireDefault(require("./Uppy.js"));
exports.default = _Uppy.default;
exports.Uppy = _Uppy.default;
var _UIPlugin = _interopRequireDefault(require("./UIPlugin.js"));
exports.UIPlugin = _UIPlugin.default;
var _BasePlugin = _interopRequireDefault(require("./BasePlugin.js"));
exports.BasePlugin = _BasePlugin.default;
var _loggers = require("./loggers.js");
exports.debugLogger = _loggers.debugLogger;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }